var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup__forgot-password signup__forgot-password--default"},[_c('div',{staticClass:"mb-4"},[_c('forgot-password-link',{attrs:{"forgotPasswordRoute":"/forgot-password"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }